import type { ProductDto } from "../../../../api";

export type ProductLifecycleStatus = "live" | "inactive" | "discontinued";

export const DISCONTINUED_MARKER = "[procurtal:lifecycle=discontinued]";

export function getProductLifecycleStatus(
  product: Pick<ProductDto, "active" | "notes">,
): ProductLifecycleStatus {
  if (product.active) return "live";
  if (product.notes?.includes(DISCONTINUED_MARKER)) return "discontinued";
  return "inactive";
}

export function getProductLifecycleLabel(status: ProductLifecycleStatus): string {
  if (status === "live") return "Live";
  if (status === "discontinued") return "Discontinued";
  return "Inactive";
}
